export function footerFunc() {
  console.log('フッター関連JS');
}